import { parsePhoneNumber } from 'awesome-phonenumber'

// UK postcode validation helper
export async function validateUkPostcode(postcode) {
  const cleanPostcode = postcode.replace(/[^A-Z0-9]/gi, '')
  try {
    const response = await fetch(`https://api.postcodes.io/postcodes/${cleanPostcode}/validate`)
    if (response.status === 404) return false
    if (!response.ok) {
      console.error('Error validating UK postcode: HTTP', response.status)
      return false
    }
    const data = await response.json()
    if (!data || !data.result) {
      return false
    }
    return data.result
  } catch (error) {
    console.error('Error validating UK postcode:', error)
    return false
  }
}

const EU_POSTCODE_PATTERNS = {
  BE: /^\d{4}$/,
  ES: /^\d{5}$/,
  FR: /^\d{5}$/,
  IE: /^[A-Z]\d{2}\s?[A-Z0-9]{4}$/,
  NL: /^\d{4}\s?[A-Z]{2}$/,
  SE: /^\d{3}\s?\d{2}$/,
  DE: /^\d{5}$/
}

export function validateEuPostcode(postcode, country) {
  const pattern = EU_POSTCODE_PATTERNS[country]
  if (!pattern) return false
  return pattern.test(String(postcode).trim().toUpperCase())
}

// UK mobile validation helper
export function parseAndValidateUkMobile(number) {
  const pn = parsePhoneNumber(number, 'GB')
  return pn.isValid() && pn.isMobile() ? pn.getNumber('e164') : null
}

// US zipcode validation helper
export async function validateUsZipcode(zipcode, state) {
  const cleanZipcode = zipcode.replace(/\s+/g, '').replace(/[^0-9]/g, '') // accept 5 or 9 digit (zip+4)
  try {
    const response = await fetch(`https://api.zippopotam.us/us/${cleanZipcode}`)
    if (response.status === 404) return false
    if (!response.ok) {
      console.error('Error validating US ZIP code: HTTP', response.status)
      return false
    }
    const data = await response.json()

    if (!data || !data.places || data.places.length === 0) {
      return false
    }

    const apiStateAbv = data.places[0]['state abbreviation']
    const apiStateName = data.places[0]['state']
    // compare cleaned user input with API response (case & whitespace insensitive)
    if (
      apiStateAbv.trim().toUpperCase() === state.trim().toUpperCase() ||
      apiStateName.trim().toUpperCase() === state.trim().toUpperCase()
    ) {
      return true
    } else {
      return false
    }
  } catch (error) {
    console.error('Error validating US ZIP code:', error)
    return false
  }
}

// US mobile validation helper
export function parseAndValidateUsMobile(number) {
  const pn = parsePhoneNumber(number, 'US')
  return pn.isValid() && pn.isMobile() ? pn.getNumber('e164') : null
}
